import React from 'react';
import LiquidEther from './LiquidEther';
import { useConversationPalette } from '../conversation/ConversationTheme';

interface LiquidEtherBackgroundProps {
  isVisible: boolean;
}

export const LiquidEtherBackground: React.FC<LiquidEtherBackgroundProps> = ({ isVisible }) => {
  const palette = useConversationPalette();
  if (!isVisible) return null;

  // Mist uses its own brand dye, separate from text and button shades.
  // Read straight off <html data-theme> to stay independent of any provider
  // (this also renders inside the embed iframe and the respondent join flow).
  const isLight = typeof document !== 'undefined'
    && document.documentElement.getAttribute('data-theme') === 'light';
  const colors = palette
    ? isLight ? palette.mistLight : palette.mistDark
    : isLight
    ? ['#C4B5FD', '#A88FFF', '#D9CDFF']
    : ['#6E3FFF', '#5929E8', '#A88FFF'];

  return (
    <div
      className="hidden md:block"
      style={{
        width: '100%',
        height: '100%',
        minHeight: '100vh',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 0,
        pointerEvents: 'none'
      }}>
      <LiquidEther
        colors={colors}
        mouseForce={15}
        cursorSize={100}
        isViscous={true}
        viscous={60}
        iterationsViscous={6}
        iterationsPoisson={12}
        resolution={0.5}
        isBounce={true}
        autoDemo={true}
        autoSpeed={0.2}
        autoIntensity={isLight ? palette ? 2.2 : 0.85 : 1.2}
        takeoverDuration={0.25}
        autoResumeDelay={10}
        autoRampDuration={0.6}
      />
    </div>
  );
};
